﻿export const GROUP = 'GROUP';
export const GEOSERVICE = 'GEOSERVICE';
export const ENTITY = 'ENTITY';
export const LAYER = 'LAYER';
export const OSM = 'OSM';
export const WMS = 'WMS';
export const WMTS = 'WMTS';
export const WFS = 'WFS';
export const GEOJSON = 'GEOJSON';
export const URL = 'URL';
export const XP_NATIVE = 'NATIVE_XP';
export const TEMPORARY_VECTOR = 'TEMPORARY_VECTOR';
export const IMAGE_TILE = 'IMAGE_TILE';
export const VECTOR_TILE = 'VECTOR_TILE';
export const NATIVE_XP = 'NATIVE_XP';
export const MEASUREMENTS = 'MEASUREMENTS';
export const SPATIAL_SEARCH = 'SPATIAL_SEARCH';
export const SPATIAL_SEARCH_RESULT = 'SPATIAL_SEARCH_RESULT';
export const SEARCH = 'SEARCH';
export const DIMENSIONING = 'DIMENSIONING';
export const SNAP = 'SNAP';
export const REDLINE = 'REDLINE';
export const SELECTION = 'SELECTION';
export const EXPORT = 'EXPORT';
export const INTERACTION_TOOLS = 'INTERACTION_TOOLS';
export const EDITING = 'EDITING';